import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import Cursor from './components/Cursor';
import Hero from './components/hero';
import Skills from './components/skill';
import Projects from './components/projects';
import Experience from './components/experience';
import Education from './components/education';
import Organizations from './components/organizations';
import Contact from './components/together';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Cursor />
    <App />
    <Hero />
    <Skills />
    <Projects />
    <Experience />
    <Education />
    <Organizations />
    <Contact />
  </React.StrictMode>
);
